import React, { FC, useRef, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Checkbox, FormInstance, SelectProps } from "antd";
import {
  AppButton,
  AuthLayout,
  Form,
  FORM_FIELD_TYPES,
  IFormItems,
} from "site/ui/base";
import { countries } from "./data";

const CheckboxWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-top: 1rem;
  color: #666;
  font-size: 0.875rem;

  a {
    color: #5575f7;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox-inner {
    border-radius: 4px;
  }
`;
const formItems: IFormItems[] = [
  {
    fieldType: FORM_FIELD_TYPES.SELECT,
    itemProps: {
      name: "gender",
      label: "Gender",
      rules: [{ required: true, message: "Please select your role!" }],
    },
    fieldProps: {
      placeholder: "Male",
      size: "large",
      options: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" },
        { value: "other", label: "Other" },
      ],
    },
  },
  {
    fieldType: FORM_FIELD_TYPES.SELECT,
    itemProps: {
      name: "country",
      label: "Country",
      rules: [{ required: true, message: "Please select your country!" }],
    },
    fieldProps: {
      placeholder: "Nigeria",
      size: "large",
      allowClear: true,
      showSearch: true,
      // allow: true,
      options: countries.map(item => ({ value: item.code, label: item.name })),
      filterOption: (inputValue, option) =>
        (option?.label as string).toLocaleLowerCase()?.includes(inputValue.toLowerCase()),
    } as SelectProps,
  },
  {
    fieldType: FORM_FIELD_TYPES.SELECT,
    itemProps: {
      name: "profession",
      label: "Your profession",
      rules: [{ required: true, message: "Please select your profession!" }],
    },
    fieldProps: {
      placeholder: "Medical personnel (Doctors, Nurses, etc.)",
      size: "large",
      options: [
        { value: "doctor", label: "Medical doctor" },
        { value: "nurse", label: "Nurse" },
        { value: "physiotherapist", label: "Physiotherapist" },
        { value: "dentist", label: "Dentist" },
        { value: "pharmacist", label: "Pharmacist" },
        { value: "therapist", label: "Therapist" },
        { value: "others", label: "Others" },
      ],
    },
  },
  {
    fieldType: FORM_FIELD_TYPES.SELECT,
    itemProps: {
      name: "studentLevel",
      label: "Career stage",
      rules: [
        { required: true, message: "Please select your career stage!" },
      ],
    },
    fieldProps: {
      placeholder: "Other",
      size: "large",
      options: [
        { value: "student", label: "Student" },
        { value: "beginner", label: "Beginner" },
        { value: "earlyCareer", label: "Early Career" },
        { value: "midLevel", label: "Mid Level" },
        { value: "highLevel", label: "High Level" },
      ],
    },
  },
  // {
  //   fieldType: FORM_FIELD_TYPES.SELECT,
  //   itemProps: {
  //     name: "testType",
  //     label: "Exam preparation",
  //     rules: [
  //       { required: true, message: "Please select your exam preparation!" },
  //     ],
  //   },
  //   fieldProps: {
  //     placeholder: "Select your exam preparation",
  //     size: "large",
  //     options: [
  //       { value: "usmle", label: "USMLE" },
  //       { value: "plab", label: "PLAB" },
  //       { value: "other", label: "Other" },
  //     ],
  //   },
  // },
];
interface IPersonalData {
  gender: string;
  country: string;
  profession: string;
  studentLevel: string;
  testType: string;
}
export interface PersonalizationProps {
  onSignUp: (data: IPersonalData) => Promise<boolean>;
  onMoveToDashboard: () => void;
}
export const Personalization:FC<PersonalizationProps> = ({
  onSignUp, onMoveToDashboard
}) => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef<FormInstance<IPersonalData>>(null);

  const handleSubmit = (values: IPersonalData) => {
    setLoading(true);
    onSignUp(values).then(success => {
      if(success) onMoveToDashboard()
    }).finally(() => setLoading(false))
  };

  const handleContinue = () => {
    formRef.current?.submit();
  };

  return (
    <AuthLayout title="Let's personalize your experience">
      <Form
        formRef={formRef}
        items={formItems}
        formProps={{
          layout: "vertical",
          onFinish: handleSubmit,
        }}
      />

      <CheckboxWrapper>
        <StyledCheckbox>
          I agree to the <Link to="#">Terms</Link> and{" "}
          <Link to="#">Privacy Policy</Link>
        </StyledCheckbox>
      </CheckboxWrapper>

      <AppButton
        variant="primary"
        fullWidth
        loading={loading}
        onClick={handleContinue}
        style={{ marginTop: "1.5rem" }}
      >
        Let's go!
      </AppButton>
    </AuthLayout>
  );
};
